<template>
  <div class="item" @click.capture="showModal">
    <div v-if="product.PhotoUrl" class="item-img">
      <div
          v-lazy:background-image="product.PhotoUrl"
          class="product-div-img"
          :style="imageRatioStyle"
      >
        <div class="triangle-container">
          <div v-if="status === undefined">
            <div
              class="triangle-topright-img"
              v-if="product.Status == 3 || product.Status == 2||product.Status == 1"
              :class="{
              'triangle-topright-img-popular':product.Status == 2,
              'triangle-topright-img-sold':product.Status == 3,
              'triangle-topright-img-new':product.Status == 1
              }"
            >
              <span>{{ product.Status | formatStatus(this) }}</span>
            </div>
          </div>
          <div v-else>
            <div
              class="triangle-topright-img"
              v-if="status == 3 || status == 2|| status == 1"
              :class="{
              'triangle-topright-img-popular':status == 2,
              'triangle-topright-img-sold':status == 3,
              'triangle-topright-img-new':status == 1
              }"
            >
              <span>{{ status | formatStatus(this) }} </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="triangle-container">
        <div v-if="status === undefined">
          <div
            class="triangle-topright-noimg"
            v-if="product.Status == 3 || product.Status == 2||product.Status == 1"
            :class="{
            'triangle-topright-img-popular':product.Status == 2,
            'triangle-topright-img-sold':product.Status == 3,
            'triangle-topright-img-new':product.Status == 1
            }"
          >
            <span>{{ product.Status | formatStatus(this) }}</span>
          </div>
        </div>
        <div v-else>
          <div
            class="triangle-topright-noimg"
            v-if="status == 3 || status == 2|| status == 1"
            :class="{
            'triangle-topright-img-popular':status == 2,
            'triangle-topright-img-sold':status == 3,
            'triangle-topright-img-new':status == 1
            }"
          >
            <span>{{ status | formatStatus(this) }} </span>
          </div>
        </div>
      </div>
    </div>
    <div   :class="isSushi ? 'item-details-sushi' : 'item-details'">
      <h2 :class="isSushi ? 'montserrat-700 item-title-sushi' : 'item-title'">{{ getProductName() }}</h2>
      <p v-html="getProductDescription()" class="block-with-text-mobile" :class="isSushi && 'montserrat-400 ' "></p>
    </div>
    <div class=" d-flex" :class="isSushi  ? 'item-price-sushi ' : 'item-price'">
      <h2  :class="isSushi && 'montserrat-700'" v-if="category.Price > 0">{{ category.Price | formatMoney(currencySign) }}</h2>
      <ul>
        <li
            v-for="(dietary, index) in dietaryList"
            :key="index"
            :style="getIconStyle(dietary)"
            :title="dietary.Name"
            :class="isSushi && 'montserrat-500'"
        ></li>
      </ul>
    </div>
    <div v-if="status && status == 3" class="sold-out">
      <h4></h4>
    </div>
    <div v-if="status === undefined && product.Status == 3" class="sold-out">
      <h4></h4>
    </div>
    <AddToCart
        v-if="isModalVisible"
        :price="category.Price"
        :product-id="category.ProductID"
        :category="category"
        :parent-category="parentCategory"
        :product="product"
        :modifiers="modifiers"
        :image-styles="dialogImageRatioStyle"
        :isSushi="isSushi"
    />
  </div>
</template>

<script>
import AddToCart from "./AddToCartMobile";
import shared from "../../../sharedscripts/shop/products/Product.js";
import sharedTranslations from "@/sharedscripts/shop/products/Translations";
export default {
  name: "Product",
  components: { AddToCart },
  filters: {
    ...shared.filters
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    category: {
      type: Object,
      default: () => {}
    },
    parentCategory: {
      type: Object,
      default: () => {}
    },
    modifiers: {
      type: Object,
      default: () => {}
    },
    sectionId: {
      type: Number,
      default: 0
    },
    isSushi : {
      type : Boolean
    },
    status: {
      type: Number
    }
  },
  data() {
    return {
      isModalVisible: false,
      width: 0,
      height: 0
    };
  },
  computed: {
    ...shared.computed
  },
  mounted() {
    this.getImageWidthHeight();
  },
  methods: {
    ...shared.methods,
    ...sharedTranslations.methods,
  },
};
</script>
